import { useState, useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CodeUtil from '../../../util/CodeUtil';
import { CODE_GROUP_ID, UNIVERSITY_TYPE } from '../../../constant/Constant';
import InputBox from '../../../component/InputBox';
import NullCheckUtil from '../../../util/NullCheckUtil';
import { actionJoinUsPhase2 } from '../../../module/body/main/JoinUsPhase2Module';
import { actionFindId } from '../../../module/body/main/FindIdPwModule';
import { BlueBorderButtonBox, DisabledBorderButtonBox } from '../../../component/buttons/CustomButtonBox';
import PopupRef from '../../../component/PopupRef';
import { actionUniversityDataSearch } from '../../../module/body/system/SystemUniversityModule';
import SelectionBox from '../../../component/SelectionBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import ReCAPTCHA from 'react-google-recaptcha';

const JoinUsPhase2View = ({ setPhase }) => {
    const [email, setEmail] = useState('');
    const [universityCd, setUniversityCd] = useState(CodeUtil.getFirstCode(CODE_GROUP_ID.USER_UNIVERSITY));
    const [propDesc, setPropDesc] = useState(CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
    const [isSub, setIsSub] = useState(false);
    const [universityType, setUniversityType] = useState('');
    const [mainUniversityCd, setMainUniversityCd] = useState('');

    const dispatch = useDispatch();
    const popupRef = useRef(null);
    const [message, setMessage] = useState('');

    const [captchaValue, setCaptchaValue] = useState('');
    const API_KEY = SessionStorageUtil.getCaptcha();

    useEffect(() => {
        setPropDesc(CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd));
        dispatch(
            actionUniversityDataSearch({
                universityCd,
                callback: (result) => {
                    setUniversityType(CodeUtil.getCodeName(CODE_GROUP_ID.UNIVERSITY_TYPE, result.universityTypeCd));
                    if (result && UNIVERSITY_TYPE.SUB === result.universityTypeCd) {
                        setIsSub(true);
                        setMainUniversityCd(
                            CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, result.mainUniversityCd),
                        );
                    } else {
                        setIsSub(false);
                        setMainUniversityCd('');
                    }
                },
            }),
        );
    }, [universityCd]);

    useEffect(() => {
        {
            !SessionStorageUtil.getAgreeAll() &&
                popupRef.current.openInfo(
                    '개인정보 수집에 동의하지 않아 개인정보 수집 동의 페이지로 이동 합니다.',
                    () => {
                        return function () {
                            setPhase(1);
                        };
                    },
                );
        }
    }, []);

    const sendEmail = (e) => {
        if (NullCheckUtil.isEmpty(email)) {
            popupRef.current.openAlert('메일 아이디를 입력해주세요.');
        } else if (email.indexOf('@') > 0) {
            popupRef.current.openAlert('메일 아이디에 "@"가 포함 되어 있습니다. 아이디만 입력해 주세요.');
        } else {
            dispatch(
                actionFindId({
                    email: email + '@' + propDesc,
                    callback: (findIdResult) => {
                        if (findIdResult) {
                            setMessage('해당 이메일은 가입되어 있습니다.');
                        } else {
                            dispatch(
                                actionJoinUsPhase2({
                                    data: {
                                        email: email + '@' + propDesc,
                                        userUniversityCd: universityCd,
                                        captchaValue,
                                    },
                                    callback: () => {
                                        setMessage(
                                            '메일이 발송되었습니다. 수신받은 메일을 이용하여 회원가입을 완료하세요.',
                                        );
                                    },
                                }),
                            );
                        }
                    },
                }),
            );
        }
    };

    return (
        <>
            <div className='join-content'>
                <h3 className='sub-tit'>본인인증 정보 입력</h3>
                <div className='personal-info-box'>
                    <div className='certify-box'>
                        <div style={{ paddingBottom: 40 }}>
                            <ReCAPTCHA
                                sitekey={API_KEY}
                                onChange={(value) => {
                                    setCaptchaValue(value || '');
                                }}
                            />
                        </div>
                        <div className='find-info-form'>
                            <SelectionBox
                                title='소속대학'
                                size='large'
                                useAll={false}
                                value={universityCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY).filter(
                                    (code) => code.useStatusCd === 'ENABLED',
                                )}
                                onChange={(e) => setUniversityCd(e.target.value)}
                            />
                            <div className='mail-addr-delimeter' />
                            <InputBox title='대학타입' size='medium' value={universityType} disabled={true} />
                            {isSub && (
                                <div className='right-box'>
                                    <div className='mail-addr-delimeter' />
                                    <InputBox title='주관대학' size='medium' value={mainUniversityCd} disabled={true} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='certify-box'>
                        <label htmlFor='이메일'>이메일</label>
                        <div className='find-info-form'>
                            <InputBox
                                placeholder='이메일 ID를 입력하세요'
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <div className='mail-addr-delimeter'>@</div>
                            <InputBox
                                value={propDesc}
                                disabled={
                                    CodeUtil.getPropDescByCode(CODE_GROUP_ID.USER_UNIVERSITY, universityCd) && true
                                }
                                onChange={(e) => setPropDesc(e.target.value)}
                                placeholder='이메일 주소를 입력하세요'
                            />
                            <div className='form-btn-box'>
                                {!captchaValue || captchaValue == '' ? (
                                    <DisabledBorderButtonBox title='CAPTCHA 미인증' />
                                ) : (
                                    <BlueBorderButtonBox title='인증메일 발송' onClick={(e) => sendEmail(e)} />
                                )}
                            </div>
                        </div>
                        <ul className='explain-txt'>
                            <li>
                                첨단분야 혁신융합대학사업(미래자동차)의 수강신청지원시스템 사용을 위한 인증으로 본교의
                                이메일 통한 인증만 가능합니다. 본교 이메일이 없는 경우는 직접 입력하여 인증 합니다.
                            </li>
                            <li>타인의 개인정보를 도용하여 인증할 경우 내부 규정에 따라 강력하게 처벌됩니다.</li>
                            <li>인증 메일은 24시간 동안 유효합니다.</li>
                        </ul>
                    </div>
                </div>
                <div className='join-btn-box btn-wrap'>
                    <div className='join-message'>
                        <p className='find-red-txt'>{message}</p>
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default JoinUsPhase2View;
